import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import ReturnToMerchantLink from '../../components/returnToMerchant';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';
import templateData from '../../utility/getTemplateData';
import { UNENROLLED_CHARITY_DONATION_BLOCKED } from '../../../../constants/constants';

const SenderEligibilityErrorTile = ({ organizationName, returnUrl }) => {
  const worldReady = useContext(WorldReadyContext);
  let messageKey = 'errors.landingerror.error.sendDonationNotAllowed';

  if (
    templateData.senderEligibilityCode === UNENROLLED_CHARITY_DONATION_BLOCKED
  ) {
    const blockingKey = 'errors.paymentError.unenrolledCharityDonationBlocked.title';
    const formatted = new MessageFormat(worldReady, { id: blockingKey }).format();
    messageKey = formatted === blockingKey ? 'errors.landingerror.error.senderIneligible' : blockingKey;
  }

  return (
    <div className="sender-eligibility-error-tile">
      <HeadingText size="sm">
        <Message id={messageKey} />
      </HeadingText>
      {returnUrl && (
        <ReturnToMerchantLink
          returnLabel={new MessageFormat(worldReady, {
            id: 'errors.landingerror.label.returnTo',
          }).format({ orgName: organizationName })}
          organizationName={organizationName}
          returnUrl={returnUrl}
        />
      )}
    </div>
  );
};

SenderEligibilityErrorTile.propTypes = {
  organizationName: PropTypes.string,
  returnUrl: PropTypes.string,
};

export default SenderEligibilityErrorTile;
